// src/pages/Journal/journalThunk.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getJournalWithDetailsApi,
  getJournalCodeApi,
  saveJournalApi,
  deleteJournalApi,
  getJournalCodesApi
} from "../../apiservice/accounts";
import { getAccountBySeachApi } from "../../apiservice/setting";

// fetch list (with details)
export const fetchJournals = createAsyncThunk(
  "journals/fetchJournals",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getJournalWithDetailsApi({ oneDate: null });
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// fetch new journal code
export const fetchJournalCode = createAsyncThunk(
  "journals/fetchJournalCode",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getJournalCodeApi();
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const fetchHeadAccs = createAsyncThunk(
  "lookups/fetchHeadAccs",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getAccountBySeachApi({
      multiType: [
        "capital",
        "cash_in_hand",
        "bank_account",
        "indirect_expense",
        "intangible_asset",
        "loan",
        "investment",
        "fixed_asset",
        "creditor",
        "debitor",
        "direct_expense",
        "dutie_&_tax",
        "current_assets",
        "current_liability",
        "deposit_accounts",
        "suspense_accounts",
        "reserve_surplus",
        "direct_income",
  "sale_account",
  "purchase_account",   // ← add
  "sale_return",       // ← add
  "purchase_return",
  "direct_income",
  "indirect_income",
  "service_account",
  "service_expense_account",      ],
    });     
      return res.data?.length > 0 ? res.data : null;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || err.message);
    }
  }
);

// save journal (create / update)
export const saveJournal = createAsyncThunk(
  "journals/saveJournal",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await saveJournalApi(payload);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// delete journal
export const deleteJournal = createAsyncThunk(
  "journals/deleteJournal",
  async (jrn_id, { rejectWithValue }) => {
    try {
      const res = await deleteJournalApi({ jrn_id });
      return { id: jrn_id, msg: res.data.msg };
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const fetchExistingJournalCodes = createAsyncThunk(
  "journals/existingJournalCodes",
  async (exp_id, { rejectWithValue }) => {
    try {
      const res = await getJournalCodesApi();
   return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);


